import * as THREE from 'three';
import { Dice } from './Dice.js';
import { gameConfig } from '../config/gameConfig.js';

export class TeleportDice extends Dice {
    constructor(value = 1) {
        super(value, false);
        this.isTeleport = true;
        // 为每个传送骰子生成随机颜色
        this.color1 = new THREE.Color().setHSL(Math.random(), 0.8, 0.5);
        this.color2 = new THREE.Color().setHSL((Math.random() + 0.5) % 1, 0.8, 0.5);
        console.log(`创建传送骰子，初始值: ${value}，颜色1: ${this.color1.getHexString()}，颜色2: ${this.color2.getHexString()}`);
        console.log('【传送骰子】构造函数执行完成');
    }

    getModelPath() {
        const modelPath = gameConfig.dice.models.teleport;
        console.log('传送骰子使用模型:', modelPath);
        return modelPath;
    }

    // 更新圆环位置，使其始终位于骰子下方
    updateRingPosition() {
        if (this.teleportRing && this.mesh) {
            // 获取骰子的世界位置
            const dicePosition = this.mesh.position.clone();
            
            // 设置圆环位置，稍微低于骰子
            this.teleportRing.position.x = dicePosition.x;
            this.teleportRing.position.z = dicePosition.z;
            this.teleportRing.position.y = 3.01; // 稍微调高一点，避免与地面重叠
            
            // 更新粒子系统位置（如果存在）
            if (this.particleSystem) {
                this.particleSystem.position.x = dicePosition.x;
                this.particleSystem.position.z = dicePosition.z;
                this.particleSystem.position.y = 3.05; // 略高于光圈
            }
        }
    }
    
    // 创建粒子系统
    createParticleSystem() {
        // 创建粒子几何体
        const particleCount = 30;
        const particles = new THREE.BufferGeometry();
        const positions = new Float32Array(particleCount * 3);
        const colors = new Float32Array(particleCount * 3);
        const sizes = new Float32Array(particleCount);
        
        const color1 = this.color1;
        const color2 = this.color2;
        
        for (let i = 0; i < particleCount; i++) {
            // 生成螺旋形轨迹
            const angle = (i / particleCount) * Math.PI * 4 + Math.random() * 0.5;
            const heightOffset = (i / particleCount) * 2.0;
            const radius = 1.0 + Math.random() * 0.3;
            positions[i * 3] = Math.cos(angle) * radius;
            positions[i * 3 + 1] = heightOffset; // 在Y轴上分布
            positions[i * 3 + 2] = Math.sin(angle) * radius;
            
            // 随机颜色（在两种颜色之间插值）
            const mixFactor = Math.random();
            const particleColor = new THREE.Color().lerpColors(color1, color2, mixFactor);
            colors[i * 3] = particleColor.r;
            colors[i * 3 + 1] = particleColor.g;
            colors[i * 3 + 2] = particleColor.b;
            
            // 随机大小
            sizes[i] = Math.random() * 0.2 + 0.1;
        }
        
        particles.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        particles.setAttribute('color', new THREE.BufferAttribute(colors, 3));
        particles.setAttribute('size', new THREE.BufferAttribute(sizes, 1));
        
        // 创建粒子材质
        const particleMaterial = new THREE.PointsMaterial({
            size: 0.2,
            vertexColors: true,
            transparent: true,
            opacity: 0.6,
            blending: THREE.AdditiveBlending,
            sizeAttenuation: true,
            depthWrite: false
        });
        
        // 创建粒子系统
        const particleSystem = new THREE.Points(particles, particleMaterial);
        particleSystem.name = 'teleportParticles';
        
        return particleSystem;
    }
    
    // 更新粒子系统
    updateParticleSystem() {
        if (!this.particleSystem) return;
        
        const positions = this.particleSystem.geometry.attributes.position.array;
        const sizes = this.particleSystem.geometry.attributes.size.array;
        const particleCount = sizes.length;
        
        for (let i = 0; i < particleCount; i++) {
            // 螺旋形上升效果
            positions[i * 3 + 1] += 0.02;
            const currentAngle = Math.atan2(positions[i * 3 + 2], positions[i * 3]) + 0.02;
            const currentRadius = Math.sqrt(positions[i * 3] * positions[i * 3] + positions[i * 3 + 2] * positions[i * 3 + 2]);
            
            // 如果粒子上升到一定高度，重置回底部
            if (positions[i * 3 + 1] > 2.0) {
                positions[i * 3 + 1] = 0;
                // 重新随机位置，保持螺旋形
                const newAngle = Math.random() * Math.PI * 2;
                const radius = 1.0 + Math.random() * 0.3;
                positions[i * 3] = Math.cos(newAngle) * radius;
                positions[i * 3 + 2] = Math.sin(newAngle) * radius;
                // 重新随机大小
                sizes[i] = Math.random() * 0.2 + 0.1;
            } else {
                // 更新粒子在XZ平面的位置，使其绕Y轴旋转
                positions[i * 3] = Math.cos(currentAngle) * currentRadius;
                positions[i * 3 + 2] = Math.sin(currentAngle) * currentRadius;
            }
        }
        
        this.particleSystem.geometry.attributes.position.needsUpdate = true;
        this.particleSystem.geometry.attributes.size.needsUpdate = true;
    }
    
    processLoadedModel(model) {
        super.processLoadedModel(model);
        console.log('【传送骰子】开始处理传送骰子模型，添加特效...');
        
        // 创建地面光圈几何体
        const radius = 1.5; // 增大半径以适应地面效果
        const segments = 64; // 增加分段数使圆更平滑
        const circleGeometry = new THREE.CircleGeometry(radius, segments);
        
        // 创建自定义着色器材质
        const teleportShader = {
            uniforms: {
                time: { value: 0 },
                color1: { value: this.color1 },
                color2: { value: this.color2 },
                opacity: { value: 0.8 }
            },
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform float time;
                uniform vec3 color1;
                uniform vec3 color2;
                uniform float opacity;
                varying vec2 vUv;
                
                void main() {
                    float dist = length(vUv - vec2(0.5));
                    float wave = sin(dist * 10.0 - time * 2.0) * 0.5 + 0.5;
                    float alpha = (1.0 - dist * 2.0) * opacity;
                    vec3 color = mix(color1, color2, wave);
                    gl_FragColor = vec4(color, alpha * smoothstep(0.5, 0.4, dist));
                }
            `
        };
        
        // 创建材质
        const circleMaterial = new THREE.ShaderMaterial({
            uniforms: teleportShader.uniforms,
            vertexShader: teleportShader.vertexShader,
            fragmentShader: teleportShader.fragmentShader,
            transparent: true,
            side: THREE.DoubleSide,
            depthWrite: false
        });
        
        // 创建光圈网格
        const circle = new THREE.Mesh(circleGeometry, circleMaterial);
        circle.rotation.x = -Math.PI / 2; // 使圆形平行于地面
        circle.name = 'teleportRing';
        
        // 保存对光圈的引用
        this.teleportRing = circle;
        
        // 创建粒子系统
        this.particleSystem = this.createParticleSystem();
        
        // 添加动画更新
        this.animateRing = () => {
            if (this.teleportRing) {
                this.teleportRing.material.uniforms.time.value += 0.016; // 约60fps的更新率
                this.updateParticleSystem(); // 更新粒子系统
            }
        };
        
        // 设置标志
        this.ringAddedToScene = false;
        this.particlesAddedToScene = false;
        
        // 更新矩阵世界
        const originalUpdateMatrixWorld = model.updateMatrixWorld.bind(model);
        model.updateMatrixWorld = (force) => {
            if (model.parent && !this.ringAddedToScene && this.teleportRing) {
                model.parent.add(this.teleportRing);
                this.ringAddedToScene = true;
                console.log('传送骰子光圈已添加到场景中');
                
                // 添加粒子系统
                if (this.particleSystem && !this.particlesAddedToScene) {
                    model.parent.add(this.particleSystem);
                    this.particlesAddedToScene = true;
                    console.log('传送骰子粒子系统已添加到场景中');
                }
            }
            
            this.updateRingPosition();
            this.animateRing();
            originalUpdateMatrixWorld(force);
        };
        
        console.log('传送骰子光圈和粒子系统创建完成');
        console.log('【传送骰子】模型处理完成');
    }

    async teleport(targetDice) {
        if (this.isAnimating) {
            console.log('传送骰子正在动画中，无法进行传送');
            return;
        }
        
        console.log(`开始传送动画，目标骰子值: ${targetDice.topValue}`);
        this.isAnimating = true;

        const startPosition = this.mesh.position.clone();
        const endPosition = targetDice.mesh.position.clone();
        const midPosition = startPosition.clone().add(endPosition).multiplyScalar(0.5);
        midPosition.y += 5; // 弧线的最高点

        console.log('传送路径信息:', {
            起点: {
                x: startPosition.x.toFixed(2),
                y: startPosition.y.toFixed(2),
                z: startPosition.z.toFixed(2)
            },
            终点: {
                x: endPosition.x.toFixed(2),
                y: endPosition.y.toFixed(2),
                z: endPosition.z.toFixed(2)
            },
            中点: {
                x: midPosition.x.toFixed(2),
                y: midPosition.y.toFixed(2),
                z: midPosition.z.toFixed(2)
            }
        });

        const curve = new THREE.QuadraticBezierCurve3(
            startPosition,
            midPosition,
            endPosition
        );

        const points = curve.getPoints(50);
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const material = new THREE.LineBasicMaterial({ color: 0x00ffff });
        const curveObject = new THREE.Line(geometry, material);
        if (!this.scene) {
            console.error('【传送骰子】错误：scene属性未设置，无法添加曲线对象');
            // 尝试从mesh获取scene
            if (this.mesh && this.mesh.parent) {
                this.scene = this.mesh.parent;
                console.log('【传送骰子】已从mesh.parent获取scene');
            } else {
                console.error('【传送骰子】无法获取scene，传送动画可能无法正常显示');
            }
        }
        
        if (this.scene) {
            this.scene.add(curveObject);
            console.log('【传送骰子】已创建传送轨迹曲线');
        }

        const duration = 1000;
        const startTime = Date.now();

        return new Promise(resolve => {
            const animate = () => {
                const elapsedTime = Date.now() - startTime;
                const progress = Math.min(elapsedTime / duration, 1);

                const position = curve.getPointAt(progress);
                this.mesh.position.copy(position);

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.scene.remove(curveObject);
                    this.isAnimating = false;
                    console.log('传送动画完成');
                    resolve();
                }
            };
            animate();
        });
    }
}